<template>
	<div class="device-overview-page">
		<!-- 设备概览模块 -->
		<div class="section device-overview breath-panel">
			<div class="header">
				<h2 class="title">设备概览</h2>
				<span class="refresh-tip">5秒自动刷新</span>
			</div>
			<div class="top-cards">
				<div class="card">
					<div class="circle-chart">
						<div id="chart1" class="chart"></div>
						<div class="chart-label">接入设备总数量</div>
					</div>
				</div>
				<div class="card">
					<div class="circle-chart">
						<div id="chart2" class="chart"></div>
						<div class="chart-label">设备整体在线率</div>
					</div>
				</div>
			</div>

			<div class="status-row">
				<div class="status-item">
					<div class="num">{{management_overviewData.onlineDeviceCount || '0'}}<span>台</span></div>
					<div class="desc">正常在线设备</div>
				</div>
				<div class="status-item">
					<div class="num">{{management_overviewData.offlineDeviceCount || '0'}}<span>台</span></div>
					<div class="desc">离线设备</div>
				</div>
				<div class="status-item">
					<div class="num">{{management_overviewData.faultDeviceCount || '0'}}<span>台</span></div>
					<div class="desc">离线复核中</div>
				</div>
			</div>

			<div class="sensor-grid">
				<div class="sensor-item" v-for="(item, index) in management_overviewData.typeStats" :key="index">
					<div class="name">{{item.typeName}}</div>
					<div class="count">{{item.total}}台</div>
					<div class="status">在线{{item.onlineCount}}/离线{{item.offlineCount}}</div>
				</div>
			</div>
		</div>

		<!-- 维保管理模块 -->
		<div class="section maintenance breath-panel">
			<div class="header">
				<h2 class="title">维保管理</h2>
				<span class="tip">第三方静态数据/自动轮播</span>
			</div>

			<div class="maintenance-top">
				<div class="maintenance-card today-expire">
					<div class="label">今日到期</div>
					<div class="num">{{device_maintenanceData?.todayDueCount || '0'}}台</div>
				</div>
				<div class="maintenance-card week-plan">
					<div class="label">本周待维保</div>
					<div class="num">{{device_maintenanceData?.weekPendingCount || '0'}}台</div>
				</div>
				<div class="maintenance-card next-sync">
					<div class="label">下次同步</div>
					<div class="num">实时</div>
				</div>
			</div>

			<div class="sync-tips">
				<div class="tip-item">静态样例数据已接入</div>
				<div class="tip-item">等待第三方维保系统正式回传后自动替换</div>
			</div>

			<div class="device-list">
				<div class="device-item" v-for="item of device_maintenanceData.items" :key="item.id">
					<div class="info">
						<div class="name">{{item.deviceName}}</div>
						<div class="detail">
							编码{{item.deviceCode}}，下次保养{{item.plannedTime}}，
							截止时间{{item.dueTime}}<br>负责人：{{item.statusName}}
						</div>
					</div>
					<div class="btns">
						<div class="btn" @click="modalClick(item)">生成计划</div>
						<div class="btn" @click="lookDetail(item)">查看详情</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 原生弹窗 -->
		<div class="maintain-modal-overlay" v-if="visible" @click.self="handleClose">
			<div class="maintain-modal">
				<!-- 标题栏 -->
				<div class="modal-header">
					<div class="header-title">
						<div class="en-title">MAINTAIN DETAIL</div>
						<div class="cn-title">{{planForm.title}}维保计划</div>
					</div>
					<img class="close-btn" @click="handleClose" src="@/assets/close.png" alt="" />
				</div>

				<!-- 主体内容 -->
				<div class="modal-body" v-if="!lookStatus">
					<div class="flex-start">
						<div>计划执行时间</div>
						<el-date-picker v-model="planForm.plannedTime" value-format="yyyy-MM-dd HH:mm:ss"
							type="datetime" placeholder="请选择执行时间" class="theme-date maintain-input"></el-date-picker>
					</div>
					<div class="flex-start">
						<div>截止时间</div>
						<el-date-picker v-model="planForm.dueTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
							placeholder="请选择截止时间" class="theme-date maintain-input"></el-date-picker>
					</div>
					<div class="flex-start">
						<div>计划备注</div>
						<el-input v-model="planForm.remark" type="textarea" :rows="3" class="maintain-input"
							placeholder="请输入备注信息"></el-input>
					</div>
					<div class="btn-group-1">
						<div :class="{btn:true,'primary-btn':bottonBtnIndex == 0}" @click="handleConfirmPlan">确认计划
						</div>
					</div>
				</div>
				<div class="modal-body modal-body2" v-else>
					<div class="flex-start">
						<div>计划执行时间</div>
						<div>{{planForm.plannedTime}}</div>
					</div>
					<div class="flex-start">
						<div>截止时间</div>
						<div>{{planForm.dueTime}}</div>
					</div>
					<div class="flex-start">
						<div>计划备注</div>
						<div>{{planForm.remark}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import { getScreenScale } from '@/utils/rem';
	export default {
		name: 'deviceManagementLeft',
		data() {
			return {
				get_work_orderData: {},
				management_overviewData: {},
				device_maintenanceData: {},
				visible: false,
				sensorList: Array(10).fill(0),
				bottonBtnIndex: null,
				lookStatus: false,
				bottonBtnShow: false,
				planForm: {
					plannedTime: "",
					dueTime: "",
					remark: ""
				},
			};
		},
		mounted() {
			this.initCharts();
			this.device_maintenance();
			// 窗口尺寸变化时重新渲染环形图（中心字号随屏幕缩放自适应）
			this._onResize = () => this.renderCharts();
			window.addEventListener('resize', this._onResize);
		},
		beforeDestroy() {
			if (this._onResize) window.removeEventListener('resize', this._onResize);
		},
		methods: {
			device_maintenance() {
				this.$http.get(this.$api.BASE_URL_Category.device_maintenance).then(res => {
					this.device_maintenanceData = res.data;
				})
			},
			get_work_order() {
				this.$http.get(this.$api.BASE_URL_Category.get_work_order, {
					orderId: this.planForm.orderId
				}).then(res => {
					this.planForm = res.data;
					this.planForm.title = res.data.deviceName;
				})
			},
			lookDetail(item) {
				this.planForm.orderId = item.orderId;
				this.get_work_order()
				this.visible = true;
				this.lookStatus = true;
			},
			modalClick(item) {
				this.planForm.orderId = item.orderId;
				this.planForm.title = item.deviceName;
				this.visible = true;
				this.lookStatus = false;
			},
			initCharts() {
				this.$http.get(this.$api.BASE_URL_Category.management_overview).then(res => {
					this.management_overviewData = res.data;
					this.renderCharts();
				})
			},
			// 渲染两个环形图（中心字号随屏幕缩放自适应）
			renderCharts() {
				const scale = getScreenScale();
				if (!this.chart1) {
					this.chart1 = echarts.init(document.getElementById('chart1'));
					this.chart2 = echarts.init(document.getElementById('chart2'));
				} else {
					this.chart1.resize();
					this.chart2.resize();
				}
				this.chart1.setOption({
					series: [{
						type: 'pie',
						radius: ['70%', '85%'],
						label: {
							show: false
						},
						data: [{
							value: this.management_overviewData.total,
							itemStyle: {
								color: '#36bffa'
							}
						}, {
							value: 0,
							itemStyle: {
								color: 'transparent'
							}
						}]
					}],
					graphic: [{
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: `{num|${this.management_overviewData.total}}{unit|台}`,
							fill: '#B3C8DC',
							rich: {
								num: {
									fontSize: Math.round(22 * scale),
									fontWeight: 'bold'
								},
								unit: {
									fontSize: Math.round(10 * scale),
									color: 'rgba(255,255,255,0.4)'
								}
							}
						}
					}]
				});

				this.chart2.setOption({
					series: [{
						type: 'pie',
						radius: ['70%', '85%'],
						label: {
							show: false
						},
						data: [{
							value: this.management_overviewData.onlineRate,
							itemStyle: {
								color: '#36bffa'
							}
						}, {
							value: 100 - this.management_overviewData.onlineRate,
							itemStyle: {
								color: 'transparent'
							}
						}]
					}],
					graphic: [{
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: `${this.management_overviewData.onlineRate}%`,
							fill: '#B3C8DC',
							fontSize: Math.round(20 * scale),
						}
					}]
				});
			},
			handleClose() {
				this.visible = false;
				this.planForm = {
					plannedTime: "",
					dueTime: "",
					remark: ""
				};
				this.bottonBtnIndex = null;
				this.bottonBtnShow = false;
			},
			handleConfirmPlan(index) {
				this.bottonBtnIndex = index;
				console.log('确认计划', this.planForm);
				this.$http.post(this.$api.BASE_URL_Category.edit_work_order, this.planForm).then(res => {
					if (res.code == 200) {
						this.$message.success(res.msg)
						this.visible = false;
						this.device_maintenance()
					}
				})
			},
			handleViewed() {},
			handleConfirmExecute() {
				console.log('确认执行');
				this.handleClose();
			},
			handleAddTodo() {},
			handleViewRecord() {},
			handleCancel() {
				this.handleClose();
			}
		}
	};
</script>

<style lang="scss" scoped>
	.device-overview-page {
		width: 420px;
		color: #B3C8DC;
		position: absolute;
		top: 90px;
		left: 10px;
		z-index: 2;

		.device-overview {
			height: 582px;
			margin-bottom: 11px;
		}

		.section {
			width: 100%;
			padding: 10px;
			background: rgba(9, 23, 36, 0.9);
			border-radius: 12px;
					// border: 1px solid #4578A8;

			.header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 16px;

				.title {
					font-size: 16px;
					margin: 0;
				}

				.refresh-tip,
				.tip {
					font-size: 12px;
					color: #aaa;
				}
			}

			.top-cards {
				display: flex;
				justify-content: space-around;
				margin-bottom: 7px;

				.card .circle-chart {
					text-align: center;

					.chart {
						width: 84px;
						height: 84px;
						margin: 0 auto 0;
					}

					.chart-label {
						font-size: 11px;
						color: #B3C8DC;
						white-space: nowrap;
					}
				}
			}

			.status-row {
				display: flex;
				justify-content: space-around;
				padding: 14px 0;
				border-top: 1px solid #3C5E7D;

				.status-item {
					width: 33.3%;
					text-align: center;
					border-right: 1px solid #25394C;

					.num {
						font-size: 24px;
						margin-bottom: 4px;

						span {
							font-size: 10px;
							color: #B3C8DC;
							margin-left: 2px;
						}
					}

					.desc {
						font-size: 10px;
						color: #B3C8DC;
					}
				}

				.status-item:last-child {
					border: none;
				}
			}

			.sensor-grid {
				display: grid;
				height: 360px;
				overflow: hidden;
				grid-template-columns: repeat(2, 1fr);
				gap: 10px;

				.sensor-item {
					width: 195px;
					height: 64px;
					padding: 6px 9px;
					text-align: center;
					background: linear-gradient(0deg, #081724 0%, #16283A 100%);
					border-radius: 7px;
							// border: 1px solid #4578A8;
					display: flex;
					flex-direction: column;
					justify-content: center;

					.name {
						font-size: 9px;
						color: #B3C8DC;
					}

					.count {
						font-size: 16px;
						margin: 6px 0;
					}

					.status {
						font-size: 9px;
						color: #B3C8DC;
					}
				}
			}
		}

		.maintenance {
			height: 387px;

			.maintenance-top {
				display: flex;
				justify-content: space-between;
				margin-bottom: 8px;

				.maintenance-card {
					width: 121px;
					height: 48px;
					background: linear-gradient(0deg, #081724 0%, #16283A 100%);
					border-radius: 8px;
					text-align: center;
							// border: 1px solid #4578A8;
					padding: 4px 10px;

					.label {
						font-size: 10px;
						color: #B3C8DC;
						margin-bottom: 8px;
					}

					.num {
						font-weight: 800;
						font-size: 16px;
						color: #B3C8DC;
					}

					&.today-expire {
						background: linear-gradient(180deg, rgba(8, 23, 36, 0) 0%, rgba(255, 74, 74, 0.5)100%);
						border: 1px solid #FF4A4A;

						.num {
							color: #FF4A4A;
						}
					}
				}
			}

			.sync-tips {
				width: 399px;
				height: 20px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-size: 12px;
				color: #B3C8DC;
				padding: 0 8px;
				background: linear-gradient(0deg, #081724 0%, #16283A 100%);
				border-radius: 4px;
						// border: 1px solid #4578A8;
			}

			.device-list {
				.device-item {
					width: 399px;
					height: 70px;
					background: linear-gradient(0deg, #081724 0%, #16283A 100%);
					border-radius: 4px;
							// border: 1px solid #4578A8;
					margin-top: 8px;
					padding: 0 8px;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.info {
						.name {
							font-weight: bold;
							font-size: 14px;
							color: #B3C8DC;
							margin-bottom: 10px;
						}

						.detail {
							font-size: 12px;
							color: #B3C8DC;
							// line-height: 12px;
						}
					}

					.btns {
						display: flex;
						gap: 8px;

						.btn {
							width: 49px;
							height: 20px;
							line-height: 16px;
							text-align: center;
							background: #284769;
							border-radius: 4px;
							border: 1px solid #7ABFFF;
							font-size: 10px;
							color: #B3C8DC;
							cursor: pointer;
						}
					}
				}
			}
		}

		.maintain-modal-overlay {
			position: fixed;
			top: 480px;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 15, 35, 0.75);
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 9999;

			.maintain-modal {
				width: 850px;
				background: rgba(9, 23, 36, 0.9);
				border-radius: 12px;
						// border: 1px solid #4578A8;
				padding: 11px 19px;
				font-size: 12px;

				.modal-header {
					display: flex;
					justify-content: space-between;
					align-items: flex-start;
					margin-bottom: 20px;

					.header-title {
						.en-title {
							font-size: 12px;
							color: #7ABFFF;
							margin-bottom: 8px;
						}

						.cn-title {
							font-weight: 500;
							font-size: 16px;
							color: #B3C8DC;
						}
					}

					.close-btn {
						cursor: pointer;
						width: 24px;
						height: 24px;
					}
				}

				.modal-body {
					.flex-start {
						display: flex;
						align-items: center;
						gap: 12px;
						margin-bottom: 16px;

						&>div:first-child {
							width: 80px;
							color: #B3C8DC;
							font-size: 12px;
						}
					}

					::v-deep .maintain-input {
						flex: 1;
						min-width: 200px;

						.el-input__inner {
							background: rgba(9, 23, 36, 0.9);
							border: 1px solid #7ABFFF;
							color: #B3C8DC;
						}

						.el-date-editor.el-input__inner {
							background: rgba(9, 23, 36, 0.9);
							border: 1px solid #7ABFFF;
							color: #B3C8DC;
						}

						textarea.el-input__inner {
							padding: 8px;
						}
					}

					::v-deep .el-picker-panel {
						background: #091724;
								// border: 1px solid #4578A8;
					}

					::v-deep .el-picker-panel__content {
						color: #B3C8DC;
					}

					.btn-group-1 {
						display: flex;
						gap: 26px;
						margin-bottom: 20px;
						align-items: center;

						.btn {
							width: 110px;
							height: 40px;
							line-height: 38px;
							text-align: center;
							background: #172434;
							border-radius: 10px;
							border: 1px solid #2C3D52;
							font-size: 16px;
							color: #B3C8DC;
							cursor: pointer;

							&.primary-btn {
								color: #349DFF;
								border: 1px solid #349DFF;
								background-color: transparent;
							}

							&:hover {
								color: #349DFF;
								border: 1px solid #349DFF;
								background-color: transparent;
							}
						}
					}
				}
				.modal-body2{
					.flex-start{
						margin-top: 40px;
					}
				}
			}
		}
	}
</style>